var $f09c5845c732c7f4$exports = {};
$f09c5845c732c7f4$exports = {
    "Clear search": `Rensa s\xf6kning`
};


export {$f09c5845c732c7f4$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
